import { ActionReducer } from '@ngrx/store';

import { setIsLoggedIn } from './actions';
import { AppState, initialState } from './initial-state';

const isLogout = (action: { type: string }) =>
  action.type === setIsLoggedIn.type &&
  !(action as ReturnType<typeof setIsLoggedIn>).payload;

export const clearSessionOnLogout =
  (reducer: ActionReducer<AppState>): ActionReducer<AppState> =>
  (state, action) =>
    reducer(
      state && isLogout(action)
        ? {
            ...initialState,
            locale: state.locale,
            languages: state.languages,
            url: state.url,
            navigation: state.navigation,
            auth: { ...state.auth, sessionToken: null },
            settings: {
              ...initialState.settings,
              system: state.settings.system,
            },
          }
        : state,
      action
    );
